const Kategoriya2113 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 1-chorak<br />
                Mavzu: Unli va undosh tovushlar <br />
“Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Nuqtalar o‘rniga qaysi so‘zlarni qo‘yish mumkin?</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘zning mazmunini tushunish, anglash qobiliyatlarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            Quyosh  … (nima qiladi?), yulduzlar (nima qiladi). <br />
            … otib, … (nima?) esa boshladi.<br />
            Onajonimning … (qanday) tafti meni har narsadan asraydi. <br/>
            Tabiatning go‘zalligi – uning …(nimasida?).
            <p><b>2-mashq. Nuqtalar o‘rniga to‘g‘ri harflarni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning imloviy ko‘nikmalarini oshirish. </p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <p>Fazo…iy, ko…not, kome…a, Sat…rn, zan…, chan…, so‘ng…i, ba…oriy, o…iyat, za…m.</p>
            <p><b> 3-mashq. To‘g‘risini yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni imloviy hushyorlikka chorlash.</p>
            <ul>
                <li>oziqa</li>
                <li>shalg‘om</li>
                <li>kometa</li>
                <li>komediya</li>
                <li>hazl</li>
                <li>sabir</li>
                <li>ushqoq</li>
            </ul>
            <p><b>4-mashq. Nuqtalar o‘rniga mos so‘zni tanlab yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning imloviy ko‘nikmalarini oshirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Do‘stlar davrani …(yayratadi, qizitadi). Bobom …(so‘zni, harfni, maqolni, hikoyani) maroq bilan ayta boshladi. Osmon podshosi – …(lochin, burgut, tuyaqush, bulbul). </p>
            <p><b>5-mashq.  Maqolning davomini yozing va izohlang.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning sintaktik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Ko‘kka …, yuzingga …. . __________________________________________</p>
            <p className="text-break">Sayoq …, … yeysan. ______________________________________________</p>
            <p><b>6-mashq. Kichik guruhlarda ishlash. Quyida berilgan so‘zlar to‘plamini o‘quvchilarga berish va so‘zlarni bo‘g‘inlar miqdoriga ko‘ra guruhlab chiqish.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni hamkorlikda mustaqil faoliyat yuritishga o‘rgatish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Sado, nadomat, sadoqat, bor, ko‘l, dengiz, kosmos, mard, o‘g‘lon, sahro, nafosat, paxtakorlar, gulzorlarni, bolalarga, ilm, shu’la, daqiqa, ko‘sak, mijoz, nadomat, yuz, atamoq, gavdalanmoq.</p>
            <p>1-guruh: bir bo‘g‘inli so‘zlarni yozing.</p>
            <p>2-guruh: ikki bo‘g‘inli so‘zlarni yozing.</p>
            <p>3-guruh: uch bo‘g‘inli so‘zlarni yozing.</p>
            <p>4-guruh: to‘rt bo‘g‘inli so‘zlarni yozing.</p>
        </div>
    )
}
export default Kategoriya2113;